// extracted by mini-css-extract-plugin
export default {"dialog-decline__message":"dialog-decline__message--NxVue","dialogDeclineMessage":"dialog-decline__message--NxVue"};